/**
 * cm-ad-card.js: the bar that tells her the gift card from our ad pages is on (Mark, 2026-10-09).
 *
 * The ad pages (your-100, give-100's link, gift?g=) put the card on her cart, where the checkout's gift
 * card extension applies it by itself. Nothing on the shop looks any different after that, so this bar,
 * at the top of every page, says the card is on and when it ends, and shows the code on a tap.
 *
 * Silent unless that page left a card in localStorage (cm_ad_card). Once a visit it checks the card is
 * still live (spent, switched off and expired cards are forgotten) and that it is still on the cart (a
 * finished checkout starts a new cart). Dismissable for the visit. No emojis, per the house style.
 * Source of truth: docs/emamaco-tiktok-pages/theme/ in the convomesh repo.
 */
(function () {
  var KEY = 'cm_ad_card';
  var API = 'https://api.convomesh.com';
  if (/^\/pages\/(your-100|give-100|gift)\/?$/.test(location.pathname)) return;
  // Landed from a card link (our email/SMS ?gcect=, Shopify's card email ?gch=): emamaco-giftcard-link.js
  // puts THAT card on the cart and keeps it here. Stand aside, or this would put an older card back.
  if (/[?&](gcect|gch)=/.test(location.search)) return;

  var card = null;
  try { card = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return; }
  if (!card || !card.g || !card.code || !card.expires_on) return;

  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('cm:card-checked', { detail: { live: false, cents: 0 } })); } catch (e) {}
  }
  if (card.expires_on < today()) { forget(); return; }
  try { if (sessionStorage.getItem('cm_ad_card_hidden')) return; } catch (e) {}

  function money(c) { var d = Number(c) / 100; return '$' + (d % 1 === 0 ? String(d) : d.toFixed(2)); }
  function day(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!m) return '';
    if (iso === today()) return 'tonight';
    try { return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString('en-AU', { weekday: 'long' }); } catch (e) { return ''; }
  }
  function fmt(c) { return String(c).toUpperCase().replace(/(.{4})(?=.)/g, '$1 '); }

  function onCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.attributes && String(c.attributes.emamaco_gift_card || '').toUpperCase() === String(card.code).toUpperCase()) return;
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { emamaco_gift_card: String(card.code).toUpperCase() } }),
        });
      }).catch(function () {});
  }

  function render(amountCents) {
    if (document.getElementById('cm-ad-card')) return;
    var st = document.createElement('style');
    st.textContent = [
      '#cm-ad-card{background:#1d1b19;color:#fff;font:600 13px/1.35 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;position:relative;z-index:5}',
      '#cm-ad-card .cmb-in{display:flex;align-items:center;gap:10px;max-width:1200px;margin:0 auto;padding:9px 40px 9px 16px}',
      '#cm-ad-card .cmb-t{flex:1;min-width:0}',
      '#cm-ad-card b{color:#E8846C;font-weight:800}',
      '#cm-ad-card button{appearance:none;background:none;border:0;color:#fff;font:inherit;cursor:pointer;padding:0}',
      '#cm-ad-card .cmb-show{text-decoration:underline;white-space:nowrap;font-weight:800}',
      '#cm-ad-card .cmb-x{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:28px;height:28px;font-size:20px;line-height:1;color:#bbb}',
      '#cm-ad-card .cmb-code{display:block;margin-top:4px;letter-spacing:.12em;font-weight:800}',
    ].join('');
    document.head.appendChild(st);
    var bar = document.createElement('div');
    bar.id = 'cm-ad-card';
    bar.setAttribute('role', 'status');
    var when = day(card.expires_on);
    bar.innerHTML = '<div class="cmb-in"><div class="cmb-t">Your <b>' + money(amountCents) + '</b> gift card is on. It comes off at checkout' +
      (when ? ', ends ' + when : '') + '.<span class="cmb-code" hidden></span></div>' +
      '<button type="button" class="cmb-show">Show code</button><button type="button" class="cmb-x" aria-label="Hide">&times;</button></div>';
    document.body.insertBefore(bar, document.body.firstChild);
    var codeEl = bar.querySelector('.cmb-code'), show = bar.querySelector('.cmb-show');
    show.addEventListener('click', function () {
      if (codeEl.hidden) {
        codeEl.textContent = fmt(card.code); codeEl.hidden = false; show.textContent = 'Copy';
      } else {
        try { navigator.clipboard.writeText(fmt(card.code)).then(function () { show.textContent = 'Copied'; }); } catch (e) {}
      }
    });
    bar.querySelector('.cmb-x').addEventListener('click', function () {
      bar.parentNode.removeChild(bar);
      try { sessionStorage.setItem('cm_ad_card_hidden', '1'); } catch (e) {}
    });
  }

  function start() {
    var checked = null;
    try { checked = JSON.parse(sessionStorage.getItem('cm_ad_card_checked') || 'null'); } catch (e) {}
    if (checked) {
      if (checked.live) {
        render(checked.cents);
        onCart().then(function () { try { window.dispatchEvent(new CustomEvent('cm:card-checked', { detail: { live: true, cents: checked.cents } })); } catch (e) {} });
      }
      return;
    }
    fetch(API + '/giftcard/emamaco/ad/card?g=' + encodeURIComponent(card.g) + '&live=1')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.card;
        if (!c) { forget(); return; }
        var cents = typeof c.balance_cents === 'number' ? c.balance_cents : c.amount_cents;
        var live = !c.expired && c.enabled !== false && cents > 0;
        try { sessionStorage.setItem('cm_ad_card_checked', JSON.stringify({ live: live, cents: cents })); } catch (e) {}
        if (!live) { forget(); return; }
        // The product page's price and the cart drawer show the card's effect (window.cmHeldCard): tell them once the
        // card is on the cart with its balance known, so they read a cart that has it.
        onCart().then(function () {
          try { window.dispatchEvent(new CustomEvent('cm:card-checked', { detail: { live: true, cents: cents } })); } catch (e) {}
        });
        render(cents);
      })
      .catch(function () { render(card.amount_cents); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
